import { render, staticRenderFns } from "./BoxFooter.vue?vue&type=template&id=384d55f2"
import script from "./BoxFooter.vue?vue&type=script&lang=ts"
export * from "./BoxFooter.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports